import { Checkbox, MenuItem as MaterialMenuItem, MenuItemProps as MaterialMenuItemProps, Radio } from '@mui/material';
import React, { FC, PropsWithChildren } from 'react';

export interface SelectItemProps extends MaterialMenuItemProps {
  id: string;
  type?: 'radio' | 'checkbox' | 'none';
  checked?: boolean;
}

export const SelectFieldItem: FC<PropsWithChildren<SelectItemProps>> = ({
  id,
  type = 'none',
  checked = false,
  children,
  ...props
}: SelectItemProps): React.ReactElement => {
  return (
    <MaterialMenuItem id={`${id}-item`} {...props}>
      {type === 'radio' ? <Radio checked={checked} /> : null}
      {type === 'checkbox' ? <Checkbox checked={checked} /> : null}
      {children}
    </MaterialMenuItem>
  );
};
